import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-arch-build',
	templateUrl:'./BuildPipelinePage.html',
	styles: [],
	styleUrls:['./BuildPipelinePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BuildPipelinePage
{
	mdContent_27 = `At build time, the Angular Maven Plugin scans your classpath for \`@NgApp\`-annotated classes. It invokes the TypeScript Compiler which walks every \`@NgComponent\`, \`@NgDirective\`, \`@NgDataService\`, and \`@NgRoutable\` class. For each, it generates a \`.ts\` file, registers it in the Angular module, and adds its route to the router config. The result is a complete Angular 21 project that the Angular CLI builds into a production \`dist/\` directory.`;
	mdContent_28 = `\`\`\`mermaid
%%{init: {
  'theme': 'dark',
  'themeVariables': {
    'darkMode': true,
    'background': '#1a1a2e',
    'primaryColor': '#6366f1',
    'primaryTextColor': '#e2e8f0',
    'primaryBorderColor': '#818cf8',
    'secondaryColor': '#1e293b',
    'secondaryTextColor': '#cbd5e1',
    'secondaryBorderColor': '#475569',
    'tertiaryColor': '#0f172a',
    'tertiaryTextColor': '#94a3b8',
    'tertiaryBorderColor': '#334155',
    'lineColor': '#818cf8',
    'textColor': '#e2e8f0',
    'mainBkg': '#1e293b',
    'nodeBorder': '#818cf8',
    'clusterBkg': '#0f172a',
    'clusterBorder': '#475569',
    'titleColor': '#e2e8f0',
    'edgeLabelBackground': '#1e293b',
    'nodeTextColor': '#e2e8f0',
    'actorTextColor': '#e2e8f0',
    'actorBorder': '#818cf8',
    'actorBkg': '#1e293b',
    'actorLineColor': '#818cf8',
    'signalColor': '#818cf8',
    'signalTextColor': '#e2e8f0',
    'labelBoxBkgColor': '#1e293b',
    'labelBoxBorderColor': '#475569',
    'labelTextColor': '#e2e8f0',
    'loopTextColor': '#cbd5e1',
    'noteBkgColor': '#1e293b',
    'noteBorderColor': '#6366f1',
    'noteTextColor': '#e2e8f0',
    'activationBorderColor': '#818cf8',
    'activationBkgColor': '#1e293b',
    'sequenceNumberColor': '#1a1a2e',
    'sectionBkgColor': '#1e293b',
    'altSectionBkgColor': '#0f172a',
    'gridColor': '#334155',
    'taskBorderColor': '#818cf8',
    'taskBkgColor': '#1e293b',
    'taskTextColor': '#e2e8f0',
    'activeTaskBorderColor': '#a5b4fc',
    'activeTaskBkgColor': '#312e81',
    'doneTaskBkgColor': '#475569',
    'doneTaskBorderColor': '#64748b',
    'critBorderColor': '#f87171',
    'critBkgColor': '#7f1d1d',
    'fontFamily': 'Inter, system-ui, sans-serif',
    'fontSize': '14px'
  }
}}%%
graph LR
  MVN["mvn install"] --> COMPILE["javac"]
  COMPILE --> PLUGIN["Angular Maven Plugin"]

  subgraph CODEGEN["Code Generation"]
    direction TB
    DISCOVER["Discover @NgApp"]
    TSCOMPILE["Generate .ts files"]
    MODPROC["Build module tree"]
    COMPPROC["Emit components"]
    DISCOVER --> TSCOMPILE --> MODPROC --> COMPPROC
  end

  subgraph SCAFFOLD["Project Scaffold"]
    direction TB
    DEPMGR["Write package.json"]
    APPSETUP["Write angular.json"]
  end

  PLUGIN --> CODEGEN
  PLUGIN --> SCAFFOLD
  CODEGEN --> NGBUILD["ng build --prod"]
  SCAFFOLD --> NGBUILD
  NGBUILD --> PACKAGE["dist/ → JAR"]

  style CODEGEN fill:#1e3a5f,stroke:#60a5fa,stroke-width:2px,color:#e2e8f0
  style SCAFFOLD fill:#1a3330,stroke:#34d399,stroke-width:2px,color:#e2e8f0
  style PACKAGE fill:#312e81,stroke:#818cf8,stroke-width:2px,color:#e2e8f0

\`\`\``;
}
